import { useNavigate } from "react-router-dom";
import { ApiService as api } from "../services/ApiService";
import { useSession } from "./useSession";
import urls from "../config/urls.json";
import { useState } from "react";
import moment from "moment";
import { isProd } from "../services/env";
import { useGeo } from "../hooks/useGeo";

export const useEditAppointment = () => {
    const navigate = useNavigate();
    const { update, read, batchUpdate } = useSession();
    const { geoCode } = useGeo();
    const [busy, setBusy] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [codiceFiscale, setCodiceFiscale] = useState("");
    const [codiceFiscaleError, setCodiceFiscaleError] = useState("");

    const askForEditAppointment = () => {
        // capita in "luogo" e "inserisci cf", NON in riepilogo
        if (!read("oppID") || read("oppID_external")) {
            //mostra popup
            setShowModal(true);
            update("oppID_external", "");
            // [luogo] se non ho gia read("codiceFiscale") mostro campo cf e pulsante avanti -> cfstatequidentro + prepareDataForEditAppointment
            // [inserisci cf] se ho gia read("codiceFiscale") mostro solo pulsante per andare avanti -> prepareDataForEditAppointment
            return;
        }

        prepareDataForEditAppointment();
    };

    const prepareDataForEditAppointment = async () => {
        setBusy(true);
        setCodiceFiscaleError("");
        // checkbycf(read("codiceFiscale") || cfstatequidentro)
        const cf = read("codiceFiscale") || codiceFiscale;
        update("codiceFiscale", cf);
        let prodotto = read("prodotto") || 1;
        let cfResult = {};
        try {
            // if (prodotto == 1) {
            //     cfResult = await api.CheckByCFAsync({
            //         cf,
            //     });
            // } else {
            //     cfResult = await api.GetUserDataAndAppointmentByCf(
            //         {
            //             CodiceFiscale: cf,
            //         },
            //         prodotto
            //     );
            // }
            cfResult = await api.GetUserDataAndAppointmentByCf(
                {
                    CodiceFiscale: cf,
                },
                prodotto
            );
        } catch (error) {
            setCodiceFiscaleError("C'è stato un errore con il codice fiscale inserito. <br />Per favore riprova.");
            setBusy(false);
            return;
        }

        // const appData = prodotto == 1 ? cfResult.appuntamento : cfResult.appointmentData;
        // const appuntamento =
        //     prodotto == 1
        //         ? appData
        //         : {
        //               oppID: appData.appointmentId,
        //               id_filiale: appData.pvOcsCode,
        //               utente: {
        //                   nome: cfResult.datiCliente.nome,
        //                   cognome: cfResult.datiCliente.cognome,
        //                   email: cfResult.datiCliente.email,
        //                   codice_fiscale: cfResult.datiCliente.codiceFiscale,
        //                   cap: cfResult.datiCliente.capResidenza,
        //                   cellulare: cfResult.datiCliente.cellulare,
        //               },
        //         };
        const appData = cfResult.appointmentData;
        const appuntamento = {
            oppID: appData.appointmentId,
            id_filiale: appData.pvOcsCode,
            utente: {
                nome: cfResult.datiCliente.nome,
                cognome: cfResult.datiCliente.cognome,
                email: cfResult.datiCliente.email,
                codice_fiscale: cfResult.datiCliente.codiceFiscale,
                cap: cfResult.datiCliente.capResidenza,
                cellulare: cfResult.datiCliente.cellulare,
            },
        };

        // if App, stop and switch to c5 flow
        // if (cfResult.app) {
        // ??? 1
        // if (cfResult.isAlreadyPP) {
        // ??? 2
        if (cfResult.isAlreadyC5) {
            update("prodotto", 3);
            prodotto = 3;
        }
        else {
            update("prodotto", 1);
            prodotto = 1;
        } 
        // ??? 3
        // if (cfResult.isAlreadyC5) {
        //     setC5();
        //     return;
        // }

        // update occupazione no matter what
        if (cfResult.datiCliente && cfResult.datiCliente.tipoOccupazione) {
            update("tipoOccupazione", cfResult.datiCliente.tipoOccupazione);
        } else if (cfResult.utente && cfResult.utente.impiego) {
            update("tipoOccupazione", cfResult.utente.impiego);
        } else {
            update("tipoOccupazione", "4");
        }

        //    se non appuntamento gia fissato, mostra errore sotto pulsante avanti
        if (!appuntamento.oppID) {
            setCodiceFiscaleError("Non abbiamo trovato appuntamenti.");
            //    return
            setBusy(false);
            return;
        }

        //    altrimenti update("appuntamentoGiaFissato");
        update("appuntamentoGiaFissato", appuntamento);

        // trovafiliale
        let trovaFilialeResult = {};
        try {
            if (prodotto == 1) {
                trovaFilialeResult = await api.TrovaFilialeAppuntamento({
                    codFiliale: appuntamento.id_filiale,
                });
            } else {
                if (!appData.coordinate) {
                    let coordinate = {};
                    try {
                        coordinate = await geoCode(`${appData.indirizzoFiliale},${appData.luogo}`);
                    } catch (err) {
                        console.log(err);
                    }
                    appData.coordinate = coordinate;
                    appData.capFiliale = coordinate.cap;
                }
                trovaFilialeResult = await api.TrovaFilialiC5({
                    latitude: appData.coordinate.lat,
                    longitude: appData.coordinate.lng,
                    cap: appData.capFiliale,
                });
                trovaFilialeResult = trovaFilialeResult.map((f) => {
                    return {
                        cap: f.CAPUfficio,
                        citta: f.CittaUfficio,
                        codFiliale: f.CodiceOcsPV,
                        coordinate: {
                            lat: f.Latitudine,
                            lng: f.Longitudine,
                        },
                        indirizzo: f.IndirizzoUfficio,
                        nomeFiliale: f.RagioneSociale,
                        provincia: f.ProvinciaUfficio,
                    };
                });
            }
        } catch (error) {
            setCodiceFiscaleError("C'è stato un errore con il caricamento del tuo appuntamento. <br />Per favore riprova.");
            setBusy(false);
            return;
        }

        let _orari = [];
        let _orarioScelto = {};
        if (prodotto == 3) {
            const filiali = trovaFilialeResult;
            const prom = [];
            for (let f in filiali) {
                const filiale = filiali[f];
                prom.push(
                    api.GetDayAndTimeSlot({
                        IdFiliale: filiale.codFiliale,
                        From: moment().toDate(),
                        To: moment().add(5, "days").toDate(),
                    })
                );
            }

            try {
                const listaDisponibilitaResult = await Promise.all(prom);
                for (let d in listaDisponibilitaResult) {
                    //Lista giorni disponibili per singola filiale
                    const giornoDisponibilitaResult = listaDisponibilitaResult[d];
                    let disponibilita = giornoDisponibilitaResult.Slots || [];
                    if (d == 0 && disponibilita.length == 0) {
                        disponibilita = [
                            {
                                Date: moment().format(),
                                Time: [],
                            },
                        ];
                    }
                    for (let ds in disponibilita) {
                        const disp = disponibilita[ds];
                        if (ds == 0) {
                            //Impostiamo la disponibilita per il primo giorno
                            const orari = [
                                { hour: 9, minute: 0, disponibile: false },
                                { hour: 9, minute: 30, disponibile: false },
                                { hour: 10, minute: 0, disponibile: false },
                                { hour: 10, minute: 30, disponibile: false },
                                { hour: 11, minute: 0, disponibile: false },
                                { hour: 11, minute: 30, disponibile: false },
                                { hour: 12, minute: 0, disponibile: false },
                                { hour: 12, minute: 30, disponibile: false },
                                { hour: 14, minute: 0, disponibile: false },
                                { hour: 14, minute: 30, disponibile: false },
                                { hour: 15, minute: 0, disponibile: false },
                                { hour: 15, minute: 30, disponibile: false },
                                { hour: 16, minute: 0, disponibile: false },
                                { hour: 16, minute: 30, disponibile: false },
                                { hour: 17, minute: 0, disponibile: false },
                                { hour: 17, minute: 30, disponibile: false },
                            ];
                            let primoDisponibile = null;
                            for (let t in disp.Time) {
                                const orarioDisponibile = disp.Time[t];
                                const ora = orarioDisponibile.split(":")[0];
                                const minuto = orarioDisponibile.split(":")[1];
                                for (let o in orari) {
                                    if (orari[o].hour == ora && orari[o].minute == minuto) {
                                        orari[o].disponibile = true;
                                        if (primoDisponibile == null) {
                                            primoDisponibile = orari[o];
                                        }
                                    }
                                }
                            }
                            // batchUpdate({
                            //     orari: orari,
                            //     orarioScelto: primoDisponibile,
                            // });
                            _orari = orari;
                            _orarioScelto = primoDisponibile;
                        }
                        if (!filiali[d].hasOwnProperty("days")) {
                            filiali[d].days = [];
                        }
                        if (disp != "KO") {
                            filiali[d].days.push({
                                data: disp.Date,
                                disponibilita: null,
                            });
                        }
                    }
                }
            } catch (err) {
                if (!isProd()) console.log(err);
            }
        } else if (prodotto == 1) {
            _orari = trovaFilialeResult.orariDisponibili;
            _orarioScelto = trovaFilialeResult.orariDisponibili.filter((_) => _.disponibile == true)[0];
        }

        const defFiliali = Array.isArray(trovaFilialeResult) ? trovaFilialeResult : trovaFilialeResult.filiali;

        batchUpdate({
            filiali: defFiliali,
            filialeScelta: defFiliali[0],
            disponibilita: defFiliali[0].days,
            dataScelta: defFiliali[0].days[0],
            //orari: trovaFilialeResult.orariDisponibili,
            //orarioScelto: trovaFilialeResult.orariDisponibili.filter((_) => _.disponibile == true)[0],
            orari: _orari,
            orarioScelto: _orarioScelto,
            oppID: appuntamento.oppID,
            nome: appuntamento.utente.nome,
            cognome: appuntamento.utente.cognome,
            codiceFiscale: appuntamento.utente.codice_fiscale,
            cap: appuntamento.utente.cap,
            cap_utente: appuntamento.utente.cap,
            email: appuntamento.utente.email,
            // cellulare: appuntamento.utente.telefono || appuntamento.utente.cellulare,
            cellulare: appuntamento.utente.cellulare || appuntamento.utente.telefono,
        });

        setBusy(false);
        navigate(urls.modificaAppuntamento.path, { replace: true });
    };

    const closeModal = () => {
        setBusy(false);
        setCodiceFiscaleError("");
        setCodiceFiscale("");
        setShowModal(false);
    };

    return {
        askForEditAppointment,
        showModal,
        setShowModal,
        setCodiceFiscale,
        codiceFiscale,
        codiceFiscaleError,
        prepareDataForEditAppointment,
        busy,
        closeModal,
        setCodiceFiscaleError,
    };
};
